export const getModelTitle = (modelTitleAttributes = ['model'], vehicle) => {
	const validAttributes = ['year', 'make', 'model', 'gvBodyStyle', 'trim'];
	const vehicleTitleAttributes = modelTitleAttributes.split(',');
	const titleValues = [];
	vehicleTitleAttributes.forEach((attribute) => {
		const cleanedAttribute = attribute.trim();
		if (
			validAttributes.includes(cleanedAttribute) &&
			vehicle[cleanedAttribute]
		) {
			titleValues.push(`${vehicle[cleanedAttribute]?.toString()}`);
		}
	});
	return titleValues.join(' ');
};
